module.exports = __webpack_public_path__ + "img/1280089885.65bf21ff.jpg";